import i18n from '@/core/i18n/i18n'

export function localeHook(request: Request): Request {
  const headers = new Headers(request.headers)
  headers.set('Accept-Language', i18n.language || 'es')
  return new Request(request, { headers })
}
